import { useDelete, useGet, usePost, usePut } from "../common/fetchServices";
import { AUTH_BASE_URL } from "../props";
import { notBlank } from "../util/ext";

const getAppAccountsUrl = () => `${AUTH_BASE_URL}/applications`;
const getAppAccountUrl = ({ id }) => `${AUTH_BASE_URL}/applications/${id}`;

const getAppAccountKeyStoreUrl = ({ id }) =>
  `${AUTH_BASE_URL}/applications/${id}/secret_keystore`;
const getAppAccountKeyStoreAccessKeyUrl = ({ id, accessKey }) =>
  `${AUTH_BASE_URL}/applications/${id}/secret_keystore/${accessKey}`;

export const useApplicationAccounts = () => {
  const url = `${getAppAccountsUrl()}?limit=9999`;
  return useGet(["application-accounts"], url);
};

export const useApplicationAccount = id => {
  const url = getAppAccountUrl({ id });
  return useGet(["application-accounts", { id }], url);
};

export const useApplicationAccountUpdate = () => {
  return usePut(getAppAccountUrl, {
    queriesToInvalidate: ["application-accounts"],
  });
};

export const useApplicationAccountActivate = () => {
  return usePost(getAppAccountUrl, {
    queriesToInvalidate: ["application-accounts"],
  });
};

export const useApplicationAccountDeactivate = () => {
  return useDelete(getAppAccountUrl, {
    queriesToInvalidate: ["application-accounts"],
  });
};

export const useApplicationAccountCreate = () => {
  return usePost(getAppAccountsUrl, {
    queriesToInvalidate: ["application-accounts"],
  });
};

export const useApplicationAccountKeystore = account => {
  const url = getAppAccountKeyStoreUrl({ id: account.applicationId });
  return useGet(
    ["application-accounts-keystore", { id: account.applicationId }],
    url,
    notBlank(account),
  );
};

export const useApplicationAccountKeystoreCreate = () => {
  return usePost(getAppAccountKeyStoreUrl, {
    queriesToInvalidate: ["application-accounts-keystore"],
  });
};

export const useApplicationAccountKeystoreDelete = () => {
  return useDelete(getAppAccountKeyStoreAccessKeyUrl, {
    queriesToInvalidate: ["application-accounts-keystore"],
  });
};
